import React from 'react';
import '../../menu/MenuSmall.scss';
import {Link, useLocation} from 'react-router-dom';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {FormattedMessage} from 'react-intl';
import searchFilter from '../../../searchFilter';
import useQuery from '../../../useQuery';
import {isTrue} from '../../../utility';
import {queryParameters} from '../../../qs';
import {graphqlWhoamiNextQuery} from '../../graphql';
import {useAuthorizationState} from '../../../contexts/Authorization';

const RAZZLE_APP_ACCOUNTS = process.env.RAZZLE_APP_ACCOUNTS;

const AuthorizedUserMenu = () => {
    const {whoamiNext} = useLazyLoadQuery(graphqlWhoamiNextQuery);
    const location = useLocation();
    const qps = queryParameters(location);
    return (
        <>
            <li>
                <div
                    className='padding-left-20px padding-right-20px font-weight-bold overflow-wrap-break-word line-height-40px'
                >{whoamiNext.username || whoamiNext.email}</div>
            </li>
            <li className='menu-small__section-item menu-small__section-item-with-border'>
                <a onClick={(e) => {
                    e.preventDefault();
                    setTimeout(() => {
                        window.location.href = RAZZLE_APP_ACCOUNTS + '/home?cache=0&new=true'
                            + (qps.length ? '&' + qps.join('&') : '');
                    }, 500);
                }}>
                    <FormattedMessage defaultMessage='Account'/>
                </a>
            </li>
            <li className='menu-small__section-item menu-small__section-item-with-border'>
                <Link to={`/log-out${searchFilter(location.search)}`}>
                    <FormattedMessage defaultMessage='Log out'/>
                </Link>
            </li>
        </>
    )
}

function MenuSmall({menuSmallRef, menuFlag, closeMenu}) {
    const {more} = useQuery();
    const authorized = useAuthorizationState();
    const location = useLocation();
    return (
        <div className='menu-small' ref={menuSmallRef}>
            <div className={`menu-small__content hide-large ${menuFlag ? 'menu-small__content--active' : ''}`}>
                <div className='menu-small__section'>
                    <div className='menu-small__section-header'>
                        <FormattedMessage defaultMessage='E-commerce'/>
                    </div>
                    <ul className='menu-small__section-list'>
                        <li className='menu-small__section-item'>
                            <Link to={`.${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Wallet'/>
                            </Link>
                        </li>
                        <li className='menu-small__section-item menu-small__section-item-with-border'>
                            <Link to={`/${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Marketplace'/>
                            </Link>
                        </li>
                        <li className='menu-small__section-item menu-small__section-item-with-border'>
                            <Link to={`impulses${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Orders'/>
                            </Link>
                        </li>
                    </ul>
                    <div className='menu-small__section-header'>
                        <FormattedMessage defaultMessage='Settings'/>
                    </div>
                    <ul className='menu-small__section-list'>
                        <li className='menu-small__section-item'>
                            <Link to={`/business${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Dashboard'/>
                            </Link>
                        </li>
                        <li className='menu-small__section-item'>
                            <Link to={`dashboard${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Old dashboard'/>
                            </Link>
                        </li>
                        <li className='menu-small__section-item'>
                            <Link to={`statistics${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Statistics'/>
                            </Link>
                        </li>
                        <li className='menu-small__section-item menu-small__section-item-with-border'>
                            <Link to={`/business/services${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Events'/>
                            </Link>
                        </li>
                        <li className='menu-small__section-item menu-small__section-item-with-border'>
                            <Link to={`endpoints${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Tickets'/>
                            </Link>
                        </li>
                        {isTrue(more) &&
                        <li className='menu-small__section-item menu-small__section-item-with-border'>
                            <Link to={`addls${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Additional fields'/>
                            </Link>
                        </li>
                        }
                        <li className='menu-small__section-item menu-small__section-item-with-border'>
                            <Link to={`coupons${searchFilter(location.search)}`} onClick={closeMenu}>
                                <FormattedMessage defaultMessage='Coupons'/>
                            </Link>
                        </li>
                        {isTrue(more) &&
                            <li className='menu-small__section-item menu-small__section-item-with-border'>
                                <Link to={`pools${searchFilter(location.search)}`} onClick={closeMenu}>
                                    <FormattedMessage defaultMessage='Pools'/>
                                </Link>
                            </li>
                        }
                    </ul>
                    <div className='menu-small__section-header'>
                        <FormattedMessage defaultMessage='My account'/>
                    </div>
                    <ul className='menu-small__section-list'>
                        {authorized ?
                            <AuthorizedUserMenu/>
                            :
                            <li className='menu-small__section-item'>
                                <Link to={`/log-out${searchFilter(location.search)}`}>
                                    <FormattedMessage defaultMessage='Log out'/>
                                </Link>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default React.memo(MenuSmall);